import { useSelector } from "react-redux"
import { IGeneral } from "../../../store/General"
import { StatusBadge } from "./StatusBadge"

type Props = { code: string | null | undefined }

export function InvoiceStatusBadge({ code }: Props) {
  const invoiceStatus = useSelector((s: { general: IGeneral }) => s.general.invoiceStatus)
  return <StatusBadge code={code} catalog={invoiceStatus} />
}
